import CONSTANTS from "./constants";

export function getLoadMessage (name: string) {
    if ( name === CONSTANTS.REVIEW_AND_SUBMIT || name === CONSTANTS.REVIEW_AND_ATTEST ) {
        return CONSTANTS.SUBMIT_APPLICATION;
    }
    return CONSTANTS.SAVING_DATA;
}
